import React, { useState } from 'react';
import { FiStar } from 'react-icons/fi';
import PortalHeader from '../../components/Portal/PortalHeader';
import ProductCard from '../../components/Portal/ProductCard';
import ProductDetailModal from '../../components/Portal/ProductDetailModal';
import LoginModal from '../../components/Portal/LoginModal';
import { useNewProducts } from '../../hooks/portal/usePortal';
import { useAuth } from '../../contexts/AuthContext';
import './NuevosProductos.scss';

const NuevosProductos = () => {
  const { products, loading } = useNewProducts(50); // Get up to 50 new products
  const { isAuthenticated } = useAuth();
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showLoginModal, setShowLoginModal] = useState(false);

  const handleProductClick = (product) => {
    setSelectedProduct(product);
  };

  const handleCloseModal = () => {
    setSelectedProduct(null);
  };

  const handleLoginRequired = () => {
    setShowLoginModal(true);
  };

  if (loading) {
    return (
      <div className="portal-page">
        <PortalHeader />
        <div className="portal-page__loading">Cargando nuevos productos...</div>
      </div>
    );
  }

  return (
    <div className="portal-page nuevos-productos">
      <PortalHeader />

      <div className="portal-page__container">
        <div className="nuevos-productos__header">
          <h1 className="portal-page__title">
            <FiStar /> Nuevos Productos
          </h1>
          <p className="subtitle">
            Descubre los productos más recientes en nuestro catálogo
          </p>
        </div>

        {products && products.length > 0 ? (
          <div className="productos-grid">
            {products.map((product) => (
              <ProductCard
                key={product.id}
                product={product}
                onClick={() => handleProductClick(product)}
                onLoginRequired={handleLoginRequired}
              />
            ))}
          </div>
        ) : (
          <div className="empty-state">
            <div className="empty-state__icon">
              <FiStar />
            </div>
            <h2>No hay nuevos productos disponibles</h2>
            <p>Revisa más tarde para ver las novedades</p>
          </div>
        )}
      </div>

      {selectedProduct && (
        <ProductDetailModal
          product={selectedProduct}
          onClose={handleCloseModal}
          onLoginRequired={handleLoginRequired}
        />
      )}

      <LoginModal
        isOpen={showLoginModal}
        onClose={() => setShowLoginModal(false)}
      />
    </div>
  );
};

export default NuevosProductos;
